import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

import { AuthService } from "../services/auth.service";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
} from "@azure/msal-browser";
import { UserRepositoryService } from "../services/user-repository.service";
import { User } from "../shared/models/user.model";

@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.scss"],
})
export class SignInComponent implements OnInit {
  private unsubscribe: Subject<void> = new Subject<void>();
  private readonly _destroying$ = new Subject<void>();
  user: User = null;
  loginDisplay = false;
  isLoggedIn = false;
  constructor(
    private router: Router,
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService,
    private userRepository: UserRepositoryService,
    private authService: AuthService
  ) {}

  ngOnInit() {

    this.msalService.instance.addEventCallback(async (event: any) => {
      if (
        event.eventType === EventType.SSO_SILENT_FAILURE ||
        event.eventType === EventType.ACQUIRE_TOKEN_FAILURE ||
        event.eventType === EventType.ACQUIRE_TOKEN_BY_CODE_FAILURE
      ) {
        await this.authService.logIn();
      }
    });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(async (event) => {
        if (!this.authService.authenticated) {
          await this.authService.logIn();
        } else {
          this.userRepository.getMe().subscribe((user: User) => {
            if(user) {
              this.user = user;
              this.router.navigate(["/home"], { replaceUrl: true });
            }
          });
        }
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.SSO_SILENT_SUCCESS ||
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
            msg.eventType === EventType.HANDLE_REDIRECT_END
        )
      )
      .subscribe(async (result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        if (payload && payload.account)
          this.msalService.instance.setActiveAccount(payload.account);
      });
  }
}
